import React, { useEffect, useMemo, useState } from "react";
import OrdersHeader from "./OrdersHeader";
import axios from "axios";
import OrdersSkeleton from "./OrdersSkeleton";
import OrdersTable from "./OrdersTable";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [orderSortField, setOrderSortField] = useState(null);
  const [orderSortDirection, setOrderSortDirection] = useState("asc");
  const [orderSearchTerm, setOrderSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);

  useEffect(() => {
    fetchOrders();
  }, [orderSearchTerm, currentPage, pageSize]);

  const fetchOrders = async () => {
    setLoading(true);
    axios
      .get("Orders/GetOrders", {
        params: {
          keyword: orderSearchTerm,
          page: currentPage,
          pageSize: pageSize,
        },
      })
      .then(({ data }) => {
        setOrders(data);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  };

  // Efficient filtering and sorting function using useMemo
  const filteredAndSortedOrders = useMemo(() => {
    let result = [...orders];

    // Then, sort the filtered results if a sort field is specified
    if (orderSortField) {
      result.sort((a, b) => {
        const fieldA = a[orderSortField];
        const fieldB = b[orderSortField];

        if (typeof fieldA === "string" && typeof fieldB === "string") {
          return orderSortDirection === "asc"
            ? fieldA.localeCompare(fieldB)
            : fieldB.localeCompare(fieldA);
        } else {
          // For numeric fields or dates
          if (fieldA === null || fieldA === undefined)
            return orderSortDirection === "asc" ? -1 : 1;
          if (fieldB === null || fieldB === undefined)
            return orderSortDirection === "asc" ? 1 : -1;

          return orderSortDirection === "asc"
            ? fieldA - fieldB
            : fieldB - fieldA;
        }
      });
    }

    return result;
  }, [orders, orderSortField, orderSortDirection]);

  const handleSort = (field) => {
    if (orderSortField === field) {
      setOrderSortDirection(orderSortDirection === "asc" ? "desc" : "asc");
    } else {
      setOrderSortField(field);
      setOrderSortDirection("asc");
    }
  };

  const onSearchTermFilterChange = (value) => {
    setOrderSearchTerm(value || "");
  };

  console.log("filteredAndSortedOrders", filteredAndSortedOrders);

  return (
    <div className="flex h-screen bg-slate-50">
      <div className="flex-1 flex flex-col overflow-hidden">
        <OrdersHeader onSearchTermFilterChange={onSearchTermFilterChange} />
        {loading ? (
          <OrdersSkeleton />
        ) : (
          <div className="px-6">
            <OrdersTable
              id="default-material-table"
              orders={filteredAndSortedOrders}
              handleSort={handleSort}
              sortField={orderSortField}
              sortDirection={orderSortDirection}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Orders;
